export function initFilterToggle() {
  const toggleBtn = document.getElementById('filter-toggle-btn');
  const filterRow = document.getElementById('filter-row');
  const filterForm = document.getElementById('filter-form');
  const clearBtn = document.getElementById('clear-filters-btn');

  if (!toggleBtn || !filterRow) return;

  // Initialize Bootstrap Collapse once
  const bsCollapse = new bootstrap.Collapse(filterRow, {
    toggle: false
  });

  // Show filter row if it was open before clearing (stored in localStorage)
  // This must run after bsCollapse is initialized
  if (localStorage.getItem('showFilterRow') === 'true') {
    // Check if filter row is not already shown
    if (!filterRow.classList.contains('show')) {
      bsCollapse.show();
      toggleBtn.setAttribute('aria-expanded', 'true');
    }
    // Clear the flag
    localStorage.removeItem('showFilterRow');
  }

  // Toggle filter row visibility on button click
  toggleBtn.addEventListener('click', () => {
    bsCollapse.toggle();
  });

  // Update button aria-expanded when collapse state changes
  filterRow.addEventListener('shown.bs.collapse', () => {
    toggleBtn.setAttribute('aria-expanded', 'true');
  });
  filterRow.addEventListener('hidden.bs.collapse', () => {
    toggleBtn.setAttribute('aria-expanded', 'false');
  });

  // Clear filters button
  if (clearBtn && filterForm) {
    clearBtn.addEventListener('click', () => {
      // Ensure filter row stays visible after clearing
      // Store that filter should be shown after redirect
      localStorage.setItem('showFilterRow', 'true');
      
      // Reset form inputs - handle city, organization, specialty, search, activity, participant, payment
      const cityFilter = filterForm.querySelector('#city-filter');
      const organizationFilter = filterForm.querySelector('#organization-filter');
      const specialtyFilter = filterForm.querySelector('#specialty-filter');
      const searchInput = filterForm.querySelector('#search-input');
      const activitySearch = filterForm.querySelector('#activity-search');
      const participantSearch = filterForm.querySelector('#participant-search');
      const paymentFilter = filterForm.querySelector('#payment-filter');
      
      if (cityFilter) cityFilter.value = '';
      if (organizationFilter) organizationFilter.value = '';
      if (specialtyFilter) specialtyFilter.value = '';
      if (searchInput) searchInput.value = '';
      if (activitySearch) activitySearch.value = '';
      if (participantSearch) participantSearch.value = '';
      if (paymentFilter) paymentFilter.value = '';
      
      // Get base URL without query parameters
      const baseUrl = filterForm.action;
      window.location.href = baseUrl;
    });
  }

  // Form submission handlers
  if (filterForm) {
    const citySelect = filterForm.querySelector('#city-filter');
    const organizationSelect = filterForm.querySelector('#organization-filter');
    const specialtyFilter = filterForm.querySelector('#specialty-filter');
    const searchInput = filterForm.querySelector('#search-input');
    const activitySearch = filterForm.querySelector('#activity-search');
    const participantSearch = filterForm.querySelector('#participant-search');
    const paymentFilter = filterForm.querySelector('#payment-filter');
    
    // City: auto-submit on change (select) or on Enter (text input)
    if (citySelect) {
      if (citySelect.matches('select')) {
        citySelect.addEventListener('change', () => filterForm.submit());
      } else {
        citySelect.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            filterForm.submit();
          }
        });
      }
    }
    
    // Organization dropdown: auto-submit on change
    if (organizationSelect) {
      organizationSelect.addEventListener('change', () => {
        filterForm.submit();
      });
    }
    
    // Payment dropdown: auto-submit on change (bookings page)
    if (paymentFilter) {
      paymentFilter.addEventListener('change', () => {
        filterForm.submit();
      });
    }
    
    // Specialty input: submit on Enter key press
    if (specialtyFilter) {
      specialtyFilter.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          filterForm.submit();
        }
      });
    }
    
    // Search input: submit on Enter key press
    if (searchInput) {
      searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          filterForm.submit();
        }
      });
    }
    
    // Activity search: submit on Enter (bookings page)
    if (activitySearch) {
      activitySearch.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          filterForm.submit();
        }
      });
    }
    
    // Participant search: submit on Enter (bookings page)
    if (participantSearch) {
      participantSearch.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          filterForm.submit();
        }
      });
    }
  }
}

